<template>
  <div style="width: 100%;">
    <el-date-picker @change="getAssemblyProcessShipmentWeightData" v-model="fromData.day" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                    placeholder="选择月份" :clearable="false"/>
    <div class="divSize" v-loading="assemblyProcessShipmentWeightLoading" element-loading-text="数据加载中"
         style="width: 100%;min-height: 300px;" id="assemblyProcessShipmentWeight"/>
    <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center', width: '100%',}"  :data="tableData" border style="width: 100%;height:78%;margin-top: 10px">
      <el-table-column v-for="item in tableNameList" :key="item" :prop="item" :label="item" min-width="150"/>
    </el-table>
  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgAssemblyProcessShipmentWeight",
  data() {
    return {
      fromData: {
        day:this.getDateFormat(),
      },
      tableData:[],
      tableNameList:[],
      assemblyProcessShipmentWeightPlanTableList:[],
      assemblyProcessShipmentWeightTableList:[],
      differenceTableList:[],
      rateTableList:[],
      //出货进度
      assemblyProcessShipmentWeight: {
        title: [
          {
            text: this.$t('makeSchedule.assemblyProcessShipmentAreaPage.cutProductionSchedule'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {bottom: '0',},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            barWidth: '70px',
            name: '计划',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            barWidth: '70px',
            name: '实际',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      assemblyProcessShipmentWeightLoading: false,
    }
  },methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    async getAssemblyProcessShipmentWeightData() {
      if (!this.fromData.day) {
        this.fromData.day = this.getDateFormat()
      }
      this.assemblyProcessShipmentWeightLoading = true
      let {data: res} = await this.$axios.post('mfg/shipmentSchedule/getAssemblyProcessShipmentWeightData', this.fromData);
      this.assemblyProcessShipmentWeightLoading = false
      if (res.code !== 0) {
        return this.$message.error(res.message)
      }

      this.tableNameList = res.data.tableNameList
      this.tableData = res.data.tableData
      this.assemblyProcessShipmentWeight.xAxis[0].data = res.data.xAxis
      this.assemblyProcessShipmentWeight.series[0].data = res.data.assemblyProcessShipmentWeightPlanList
      this.assemblyProcessShipmentWeight.series[1].data = res.data.assemblyProcessShipmentWeightList
      let a = this.$common.getDivisor(Math.max(...res.data.assemblyProcessShipmentWeightList))
      let b = this.$common.getDivisor(Math.max(...res.data.assemblyProcessShipmentWeightPlanList))
      let c = 0;let d = 0;
      for (let item of res.data.assemblyProcessShipmentWeightList) {
        if (c < item) {
          c = item;
        }
      }
      for (let item of res.data.assemblyProcessShipmentWeightPlanList) {
        if (d < item) {
          d = item;
        }
      }
      if (c > d) {
        c = res.data.assemblyProcessShipmentWeightList;
        d = a
      } else {
        c = res.data.assemblyProcessShipmentWeightPlanList;
        d = b
      }
      this.assemblyProcessShipmentWeight.yAxis[0].max = Math.ceil(Math.max(...c) / d) * d
      this.assemblyProcessShipmentWeight.yAxis[0].interval = Math.round(this.assemblyProcessShipmentWeight.yAxis[0].max / 5 * 100) / 100
      this.renderEcharts('assemblyProcessShipmentWeight', this.assemblyProcessShipmentWeight)
    }
  },created() {
    this.getAssemblyProcessShipmentWeightData();
  }
}
</script>

<style scoped>
.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>